import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
} from 'lucide-react';
import { useListPaginationContext } from 'ra-core';

const rowsPerPageOptions = [5, 10, 25, 50];

export function FinishedOffersPagination() {
  const {
    hasPreviousPage,
    hasNextPage,
    page,
    perPage,
    setPerPage,
    total,
    setPage,
  } = useListPaginationContext();

  const totalPages = total ? Math.ceil(total / perPage) : 1;

  const navButtonClass =
    'inline-flex items-center justify-center size-[30px] bg-secondary border border-border rounded-md text-foreground transition disabled:opacity-40 disabled:cursor-not-allowed hover:bg-muted active:scale-[0.96] focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none';

  return (
    <div className="flex items-center justify-end gap-8">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-foreground">
          Rows per page
        </span>
        <Select
          value={perPage.toString()}
          onValueChange={value => setPerPage(Number(value))}
        >
          <SelectTrigger className="h-9 w-20 bg-secondary border border-border rounded-md font-tabular">
            <SelectValue placeholder={perPage} />
          </SelectTrigger>
          <SelectContent side="top">
            {rowsPerPageOptions.map(size => (
              <SelectItem
                key={size}
                value={size.toString()}
                className="font-tabular"
              >
                {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <span className="text-sm font-medium text-foreground font-tabular">
        Page {page} of {totalPages}
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          className={navButtonClass}
          disabled={!hasPreviousPage}
          onClick={() => setPage(1)}
          aria-label="First page"
        >
          <ChevronsLeftIcon className="size-4" />
        </button>
        <button
          type="button"
          className={navButtonClass}
          disabled={!hasPreviousPage}
          onClick={() => setPage(page - 1)}
          aria-label="Previous page"
        >
          <ChevronLeftIcon className="size-4" />
        </button>
        <button
          type="button"
          className={navButtonClass}
          disabled={!hasNextPage}
          onClick={() => setPage(page + 1)}
          aria-label="Next page"
        >
          <ChevronRightIcon className="size-4" />
        </button>
        <button
          type="button"
          className={navButtonClass}
          disabled={!hasNextPage}
          onClick={() => setPage(totalPages)}
          aria-label="Last page"
        >
          <ChevronsRightIcon className="size-4" />
        </button>
      </div>
    </div>
  );
}
